import { createRouter, createWebHistory } from 'vue-router'
import { useI18n } from 'vue-i18n'
import HomeView from '@/pages/home.vue'
import TheaterView from '@/pages/theater/list.vue'
import UserView from '@/pages/profile/index.vue'
import LoginView from '@/pages/login.vue'
import SearchView from '@/pages/theater/search.vue'
import PlayletViewerView from '@/pages/theater/detail.vue'
import PlanView from '@/pages/plan/index.vue'
import PlanPointsView from '@/pages/plan/points.vue'
import PlanResultView from '@/pages/plan/result.vue'
import TermsOfServiceView from '@/pages/legal/terms-of-service.vue'
import PrivacyPolicyView from '@/pages/legal/privacy-policy.vue'
import { useUserStore } from '@/stores/user'
import { showToast } from 'vant'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'Home',
      component: TheaterView,
      meta: { keepAlive: true, showTabBar: true },
    },
    {
      path: '/theater',
      name: 'Theater',
      children: [
        {
          path: '',
          name: 'TheaterList',
          meta: { keepAlive: true, showTabBar: true },
          component: HomeView,
        },
        {
          path: 'search',
          name: 'TheaterSearch',
          component: SearchView,
        },
        {
          path: 'detail/:id',
          name: 'TheaterDetail',
          component: PlayletViewerView,
        },
      ],
    },
    {
      path: '/profile',
      name: 'Profile',
      component: UserView,
      meta: { keepAlive: true, showTabBar: true },
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginView,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfService',
      component: TermsOfServiceView,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicyView,
    },
    {
      path: '/plan',
      name: 'Plan',
      children: [
        {
          path: '',
          component: PlanView,
        },
        {
          path: 'result',
          name: 'PlanResult',
          component: PlanResultView,
        },
        {
          path: 'points',
          name: 'PlanPoints',
          component: PlanPointsView,
        },
      ],
    },
    {
      path: '/creation',
      name: 'Creation',
      component: () => import('@/pages/creation/index.vue'),
      meta: { keepAlive: true },
    },
  ],
})

const whitelist = ['/login', '/home', '/profile', '/terms-of-service', '/privacy-policy']
router.beforeEach(async (to, _, next) => {
  const userStore = useUserStore()
  const isWhitelistRoute = whitelist.includes(to.path)

  if (isWhitelistRoute) {
    if (to.path === '/login' && userStore.isLogin) {
      next({ path: '/profile' })
      return
    }

    next()
    return
  }

  if (!userStore.token) {
    next({ path: '/login', query: { redirect: encodeURIComponent(to.fullPath) } })
    return
  }

  if (userStore.profileInfo) {
    next()
    return
  }

  try {
    const ready = await userStore.ensureAuthReady()
    if (!ready) {
      next({ path: '/login', query: { redirect: encodeURIComponent(to.fullPath) } })
      return
    }

    next()
  } catch (error) {
    const { t } = useI18n()
    showToast(t('common.errors.userInfoFailed'))
    next(false)
  }
})

export default router
